import useHousePrices from './useHousePrices';
import { useQuery } from 'react-query';

export const useGetChartData = ({ validatedAddress, postcode }) => {
  const { data: housePricesData, isLoading: isLoadingHousePriceData } = useHousePrices(postcode);
  const sales = housePricesData?.sales ?? [];

  return useQuery(
    ['getChartData', validatedAddress, postcode],
    async () => {
      try {
        const seriesData = sales.map((sale) => ({
          x: new Date(sale.date).getTime(),
          y: sale.price,
          address: `${sale.address.paon || ''} ${sale.address.street || ''}`.trim(),
          propertyType: sale.propertyType || 'Unknown',
          estateType: sale.estateType || 'Unknown',
          newBuild: sale.newBuild || false,
          date: sale.date,
        }));
        seriesData.sort((a, b) => a.x - b.x);
        const averagePrice =
          sales.length > 0
            ? Math.round(sales.reduce((sum, sale) => sum + sale.price, 0) / sales.length)
            : 0;
        const propertyTypes = [...new Set(seriesData.map((item) => item.propertyType))];

        let formattedData;
        if (propertyTypes.length > 1) {
          const fullTypeGroups = {};
          seriesData.forEach((item) => {
            const fullType = item.propertyType;
            if (!fullTypeGroups[fullType]) {
              fullTypeGroups[fullType] = [];
            }
            fullTypeGroups[fullType].push(item);
          });
          formattedData = {
            series: Object.keys(fullTypeGroups).map((fullType) => {
              const displayName = fullType
                .split('-')
                .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
                .join('-');
              return {
                name: displayName,
                data: fullTypeGroups[fullType],
              };
            }),
            areaName: `${postcode} Area`,
            postcode,
            averagePrice,
          };
        } else {
          formattedData = {
            series: [
              {
                name: 'Sale Price',
                data: seriesData,
              },
            ],
            propertyAddress: `${sales[0]?.address?.paon || ''} ${
              sales[0]?.address?.street || ''
            }`.trim(),
            postcode,
            averagePrice,
          };
        }
        return formattedData;
      } catch (error) {
        console.error('Error preparing chart data:', error);
        return null;
      }
    },
    {
      enabled: !isLoadingHousePriceData && sales && sales.length > 0,
      staleTime: Infinity,
    },
  );
};
